/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Charspage_IntroInputs */

const en_fw_charspage_intro = /** @type {(inputs: Fw_Charspage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who’s who in the Firefly Wedding anime and manga, with the voice cast announced so far.`)
};

const zh_fw_charspage_intro = /** @type {(inputs: Fw_Charspage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画与漫画中的主要人物，以及目前已公布的声优阵容。`)
};

/**
* | output |
* | --- |
* | "Who’s who in the Firefly Wedding anime and manga, with the voice cast announced so far." |
*
* @param {Fw_Charspage_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_charspage_intro = /** @type {((inputs?: Fw_Charspage_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Charspage_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_charspage_intro(inputs)
	return zh_fw_charspage_intro(inputs)
});
export { fw_charspage_intro as "fw.charspage.intro" }